export default __webpack_public_path__ + "static/media/img-background.008d06ba.png";